<script setup lang="ts">
import {Model} from "@/app/Model";
import {ref} from "vue";

let model: Model = Model.getReactiveInstance();
let fakeUpdate = ref( true )
const emit = defineEmits(["recalc"]);

function goPaginazione(pageStart: number): void {
  let model: Model = Model.getReactiveInstance();
  if (pageStart != model.pen_admin.paginazioneReatoRubrica_start) {
    model.pen_admin.paginazioneReatoRubrica_start = pageStart;
    emit("recalc", pageStart);
  }
}
//@ts-ignore
window.goPaginazioneExt = goPaginazione;
//---
function renderClassFirst(): string {
  let out: string = "page-item";
  if (model.pen_admin.paginazioneReatoRubrica_start == 0) {
    out += " disabled";
  }
  return out;
}
function renderClassLast(): string {
  let out: string = "page-item";
  if (model.pen_admin.paginazioneReatoRubrica_start == model.pen_admin.paginazioneReatoRubrica_pages) {
    out += " disabled";
  }
  return out;
}
function renderClassItem(indx: number): string {
  let out: string = "page-item";
  if (model.pen_admin.paginazioneReatoRubrica_start == indx) {
    out += " active";
  }
  return out;
}
//---
function renderPaginationLong() : string{
  var max : number = model.pen_admin.paginazioneReatoRubrica_pages;
  var liDot1: string = '<li class="page-item"><a class="page-link" href="javascript:void(0);">...</a></li>';
  if (model.pen_admin.paginazioneReatoRubrica_start  <= 2) liDot1 = "";
  var liDot2: string = '<li class="page-item"><a class="page-link" href="javascript:void(0);">...</a></li>';
  if (model.pen_admin.paginazioneReatoRubrica_start > max-2) liDot2 = "";
  let classFirst: string = renderClassFirst();
  let classLast: string = renderClassLast();
  var out: string = '<li class="'+classFirst+'">' +
      '        <a class="page-link" href="javascript:void(0)" aria-label="First" onclick="goPaginazioneExt(0)">' +
      '          <span aria-hidden="true"><i class="bi bi-chevron-double-left"></i></span>' +
      '        </a>' +
      '      </li>'

  if (model.pen_admin.paginazioneReatoRubrica_start >0) {
    out+='<li class="page-item">' +
        '   <a class="page-link" onclick="goPaginazioneExt('+ (model.pen_admin.paginazioneReatoRubrica_start-1) +')"><i class="bi bi-chevron-left"></i></a>' +
        ' </li>';
  } else {
    out+='<li class="page-item disabled">' +
        '   <a class="page-link" href="javascript:void(0)"><i class="bi bi-chevron-left"></i></a>' +
        '</li>';
  }
  if (model.pen_admin.paginazioneReatoRubrica_start != 0) out+='<li class="page-item">' +
      '   <a class="page-link" onclick="goPaginazioneExt('+ 0 +')">'+ 1 +'</a>' +
      ' </li>'+ liDot1;
  out+='<li class="page-item active">' +
      '   <a class="page-link" onclick="goPaginazioneExt('+ (model.pen_admin.paginazioneReatoRubrica_start) +')">'+ (model.pen_admin.paginazioneReatoRubrica_start+1) +'</a>' +
      ' </li>';
  if (model.pen_admin.paginazioneReatoRubrica_start != max)  out+= liDot2 + '<li class="page-item">' +
      '   <a class="page-link" onclick="goPaginazioneExt('+ max +')">'+ (max+1 )+'</a>' +
      ' </li>';
  if (model.pen_admin.paginazioneReatoRubrica_start < max) {
    out+='<li class="page-item">' +
        '   <a class="page-link" onclick="goPaginazioneExt('+ (model.pen_admin.paginazioneReatoRubrica_start+1) +')"><i class="bi bi-chevron-right"></i></a>' +
        '</li>';
  } else {
    out+='<li class="page-item disabled">' +
        '   <a class="page-link" href="javascript:void(0)" onclick="goPaginazioneExt('+ (model.pen_admin.paginazioneReatoRubrica_start+1) +')"><i class="bi bi-chevron-right"></i></a>' +
        '</li>';
  }

  out +='      <li class="'+classLast+'">' +
      '        <a class="page-link" href="javascript:void(0)" aria-label="Last" onclick="goPaginazioneExt('+ model.pen_admin.paginazioneReatoRubrica_pages+')">' +
      '          <span aria-hidden="true"><i class="bi bi-chevron-double-right"></i></span>' +
      '        </a>\n' +
      '      </li>';
  return out;
}

//expose
function updatePaginazione(): void {
  //console.log("UPDATE", cid)
  model = Model.getReactiveInstance();
  fakeUpdate.value = !fakeUpdate.value;
}
defineExpose({
  updatePaginazione
});
</script>

<template>
  <nav aria-label="Paginazione" :data-fake="fakeUpdate">
    <ul class="pagination pagination-sm justify-content-end" v-if="model.pen_admin.paginazioneReatoRubrica_pages < 10">
      <li :class="renderClassFirst()">
        <a class="page-link" href="javascript:void(0)" aria-label="First" @click="goPaginazione(0)">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li v-for="(item, index) in model.pen_admin.paginazioneReatoRubrica_pages+1" :class="renderClassItem(index)"><a class="page-link" href="javascript:void(0)"  @click="goPaginazione(index)">{{ index+1 }}</a></li>
      <li :class="renderClassLast()">
        <a class="page-link" href="javascript:void(0)" aria-label="Last" @click="goPaginazione(model.pen_admin.paginazioneReatoRubrica_pages)">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>

    </ul>
    <ul class="pagination pagination-sm justify-content-end" v-else v-html="renderPaginationLong()">
    </ul>
  </nav>
</template>

<style scoped>

</style>